import _from from './from';
import _to from './to';
import type { Types } from './types';

export class SduiMap {
  static from = _from;
  static to   = _to;
}

export { Types as SduiTypes };